import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from 'containers/expertise/DetailPage';
import {
  beadGrantServices,
  broadbandLabels,
  businessOperations,
  businessPlanning,
  cabs,
  consultingBusinessServicesHeroSection,
  energyRebates,
  pricingPlansConsulting,
  regulatoryCompliance,
  strategicPlanningTraining,
  teamStuffingExpansion,
} from '../../images/expertise/consulting-business-services';

const ConsultingBusinessServices: NextPage = () => {
  return (
    <>
      <Header
        title="Consulting & Business Services"
        description="Utilities One provides specialized business and consulting services tailored to enhance operational success and regulatory compliance."
        image={consultingBusinessServicesHeroSection}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: energyRebates,
            id: 'energyRebates',
            hasListItems: true,
            title: 'Energy Rebates',
            description:
              'We help businesses navigate energy rebates and incentives for EV Charging, Energy Storage Systems, Solar Installations, and LED Retrofits.',
          },
          {
            bgImage: regulatoryCompliance,
            id: 'regulatoryCompliance',
            hasListItems: true,
            title: 'Regulatory & Compliance',
            description: 'Providing expert guidance to ensure adherence to industry standards and regulatory requirements.',
          },
          {
            bgImage: beadGrantServices,
            id: 'beadGrantServices',
            hasListItems: true,
            title: 'BEAD & Grant Services',
            description: 'Supporting clients in obtaining and managing federal and state grants for business expansion.',
          },
          {
            bgImage: cabs,
            id: 'cabs',
            hasListItems: true,
            title: 'CABS',
            description: 'Offering tailored billing solutions to manage access charges and interconnection agreements.',
          },
          {
            bgImage: broadbandLabels,
            id: 'broadbandLabels',
            hasListItems: true,
            title: 'Broadband Labels',
            description: 'Ensuring broadband providers meet labeling requirements for transparency.',
          },
          {
            bgImage: businessPlanning,
            id: 'businessPlanning',
            hasListItems: true,
            title: 'Business Planning',
            description: 'Delivering strategic insights to drive business growth and operational improvements.',
          },
          {
            bgImage: businessOperations,
            id: 'businessOperations',
            hasListItems: true,
            title: 'Business Operations',
            description: 'Enhances operational efficiency through comprehensive consulting services.',
          },
          {
            bgImage: pricingPlansConsulting,
            id: 'pricingPlansConsulting',
            hasListItems: true,
            title: 'Pricing & Plans Consulting',
            description: 'Helping optimize pricing models and service offerings to maximize revenue.',
          },
          {
            bgImage: teamStuffingExpansion,
            id: 'teamStuffingExpansion',
            hasListItems: true,
            title: 'Team Stuffing & Expansion',
            description: 'Provides staffing solutions to meet workforce demands and support growth initiatives.',
          },
          {
            bgImage: strategicPlanningTraining,
            id: 'strategicPlanningTraining',
            hasListItems: true,
            title: 'Strategic Planning & Training',
            description: 'Assisting with long-term strategy development and workforce training programs.',
          },
        ]}
      />
    </>
  );
};

export default ConsultingBusinessServices;
